import { isBrowser } from "@helpers/browser";

function blotoutSendPageView() {
  if (!isBrowser || typeof window.edgetag === "undefined") {
    return false;
  }
  window.edgetag("tag", "PageView");
  return true;
}

function blotoutSearch({ query, searchResults }) {
  if (!isBrowser) return;

  const searchProducts = searchResults.map((item) => ({
    id: item.shopify.id.replace("gid://shopify/Product/", ""),
    quantity: 1,
    item_price: parseFloat(item.shopify.variants[0].price),
    sku: item.shopify.variants[0].sku,
    title: item.contentful.title,
    description: item.contentful.description,
    category: item.shopify.category,
    brand: "Ana Luisa",
    image: item.shopify.images?.[0]?.url,
    url: `https://www.analuisa.com/products/${item.shopify.handle}/`,
  }));
  const event = {
    search: query,
    contents: searchProducts,
    currency: "USD",
  };
  window.edgetag("tag", "Search", event);
}

function blotoutViewProduct({ product }) {
  if (!isBrowser) return;

  const event = {
    currency: product?.currencyCode || "USD",
    value: parseFloat(product.final_price),
    contents: [
      {
        id: product.shopifyId.replace("gid://shopify/Product/", ""),
        quantity: 1,
        item_price: parseFloat(product.final_price),
        title: product.title,
        category: product.productType,
        image: product.images?.[0]?.url,
        url: `https://www.analuisa.com/products/${product.handle}`,
      },
    ],
  };
  window.edgetag("tag", "ViewContent", event);
}

function blotoutSendRemoveFromCart({
  price,
  title,
  productId,
  variantId,
  category,
  currency,
  quantity,
  checkoutUrl,
  productHandle,
}) {
  if (!isBrowser) return;
  const event = {
    currency,
    value: price,
    contents: [
      {
        id: productId,
        variantId,
        quantity,
        item_price: parseFloat(price),
        title,
        category,
        url: `https://www.analuisa.com/products/${productHandle}`,
      },
    ],
    checkoutUrl,
  };

  window.edgetag("tag", "RemoveFromCart", event);
}

function blotoutSendAddToCart({
  price,
  title,
  productId,
  variantId,
  category,
  currency,
  quantity,
  productHandle,
  images,
  checkoutUrl,
}) {
  if (!isBrowser) return;
  const event = {
    currency,
    value: price,
    contents: [
      {
        id: productId,
        variantId,
        quantity,
        item_price: parseFloat(price),
        title,
        category,
        image: images && images.length > 0 ? images[0].url : "",
        url: `https://www.analuisa.com/products/${productHandle}`,
      },
    ],
    checkoutUrl,
  };

  window.edgetag("tag", "AddToCart", event);
}

export {
  blotoutSendPageView,
  blotoutSendAddToCart,
  blotoutSendRemoveFromCart,
  blotoutViewProduct,
  blotoutSearch,
};
